import { h } from './fun/h'
export { Fragment } from './comp/Fragment'

export const jsx = h
export const jsxs = h
